import React from 'react';
import { Input } from 'reactstrap';

function TextInput({
  type, placeholder, id, onInput, value, className, ...props
}) {
  const onInputChanged = (e) => {
    const { value } = e.target;
    if (onInput) onInput(id, value);
  };
  return (
    <div className="form-group">
      <label htmlFor={id}>{placeholder}</label>
      {type !== 'textarea' && (
      <input
        id={id}
        className={`form-control ${className}`}
        type={type}
        // placeholder={placeholder}
        onInput={onInputChanged}
        value={value}
        {...props}
      />
      )}
      {type === 'textarea' && (
      <textarea
        id={id}
        className={`form-control ${className}`}
        // placeholder={placeholder}
        onInput={onInputChanged}
        value={value}
        {...props}
      />
      )}

    </div>
  );
}

TextInput.defaultProps = {
  type: 'text',
};
TextInput.propTypes = {};

export default TextInput;
